import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import dayjs from "dayjs"

export type TempUnavailability = {
  dayStart: dayjs.Dayjs | null
  dayEnd: dayjs.Dayjs | null
  timeStart: dayjs.Dayjs | null
  timeEnd: dayjs.Dayjs | null
  reason: string | null
  error: {
    dayStartError: boolean
    dayEndError: boolean
    timeStartError: boolean
    timeEndError: boolean
  } | null
  errorMessage: string | null
}

export type StateUnavailability = {
  tempUnavailability: TempUnavailability
}

const initialState: StateUnavailability = {
  tempUnavailability: {
    dayStart: null,
    dayEnd: null,
    timeStart: null,
    timeEnd: null,
    reason: null,
    error: null,
    errorMessage: null,
  },
}

export const unavailabilityShopSlice = createSlice({
  name: "unavailabilityShop",
  initialState,
  reducers: {
    initTempUnavailability: (state) => {
      state.tempUnavailability = initialState.tempUnavailability
    },
    setTempUnavailability: (
      state,
      action: PayloadAction<TempUnavailability>
    ) => {
      state.tempUnavailability = action.payload
    },
    setDayStart: (state, action: PayloadAction<dayjs.Dayjs | null>) => {
      state.tempUnavailability.dayStart = action.payload
    },
    setDayEnd: (state, action: PayloadAction<dayjs.Dayjs | null>) => {
      state.tempUnavailability.dayEnd = action.payload
    },
    setTimeStart: (state, action: PayloadAction<dayjs.Dayjs | null>) => {
      state.tempUnavailability.timeStart = action.payload
    },
    setTimeEnd: (state, action: PayloadAction<dayjs.Dayjs | null>) => {
      state.tempUnavailability.timeEnd = action.payload
    },
    setReason: (state, action: PayloadAction<string | null>) => {
      state.tempUnavailability.reason = action.payload
    },
    setError: (
      state,
      action: PayloadAction<{
        dayStartError: boolean
        dayEndError: boolean
        timeStartError: boolean
        timeEndError: boolean
      } | null>
    ) => {
      state.tempUnavailability.error = action.payload
    },
    setErrorMessage: (state, action: PayloadAction<string | null>) => {
      state.tempUnavailability.errorMessage = action.payload
    },
  },
})

export const {
  initTempUnavailability,
  setTempUnavailability,
  setDayStart,
  setDayEnd,
  setTimeStart,
  setTimeEnd,
  setReason,
  setError,
  setErrorMessage,
} = unavailabilityShopSlice.actions

export default unavailabilityShopSlice.reducer
